module.exports = __webpack_public_path__ + "img/error_default.7bd35b5.svg";